//Environment variables:
export const Globals = {
  get fireBaseUrl() {
    if (process.env.NODE_ENV === 'development' && process.env.APP_FIREBASE_EMULATOR === 'true') {
      return `http://localhost:5001/${process.env.APP_FIREBASE_PROJECT_ID}/us-central1/`;
    } else {
      const url = process.env.APP_FIREBASE_FUNCTIONS_URL!;
      return url.endsWith('/') ? url : `${url}/`;
    }
  },
};
export const GOOGLE_CLIENT_ID = process.env.APP_GOOGLE_CLIENT_ID;

// User & Role IDs:
export const AdminRole = '2uRlYOYN7yny6tG9a7wa';
export const SuperAdminRole = 'iGcPQKwKJTHNf5zok6I4';
export const LightingReviewerRole = 'AEgmuSwYEVat7utOfeQC';
export const InstallerRole = 'J5W0WbKNuGzIjZ2Ic23n';
export const PATHInstallerRole = 'Kw5WUEdts2OnHFAlTdno';
export const JVPartnerRole = 'JVPartner';
export const HeatherLloydUserID = 'B0GUlqD2ngfKEw4fvjWnqV58hni2';

export enum UserEmails {
  AB = 'ab@lightedison.com', // Adam Bennett
  BAC = 'bac@lightedison.com', // Bill A Clifton
  BVD = 'bvd@lightedison.com', // Becki VanDyke
  CA = 'ca@lightedison.com', // Cory Aspell
  CJS = 'cjs@lightedison.com', // Crystal J Sheridan
  EJ = 'ej@lightedison.com', // Emily Jahnke
  HL = 'hl@lightedison.com', // Heather Lloyd
  KL = 'kl@lightedison.com', // Kate Lavicky
  ML = 'ml@lightedison.com', // Matt Lowell
  SMS = 'sms@lightedison.com', // Shawn M Stutzman
}

export enum UserIds {
  JMJ = 'F2bN4HL9NkDhOwapPPtl', //John Jordan
  CA = '9g9fOFWo7Xed70lkDAwn', //Cory Aspell
  RC = '2ZpqNGYklXaT0uZTN8xq', //Russell Cordum
  DW = 'UtMrjlwT3gz9zgXOluhU', //Derek Westveer
  SR = 'jubfomZdelANl9peGRGL', //Sureka Richmond
  TMJ = 'TWvsoNjtsHhv8ZtkdUUa', //Tim Johnson
  SMS = 'CY4TFHcdwaxkpLeL4LQ2', //Shawn M Stutzman
}

// Company Information:
export const companyName = 'SitelogIQ';
export const companyWebsite = 'https://www.sitelogiq.com';
export const gridBaseURL = 'https://grid.sparkfund.com/#/';
export const companyEmailDomain = '@sparkfund.com';
export const LightEdisonLogo =
  'https://firebasestorage.googleapis.com/v0/b/light-edison.appspot.com/o/logo%2Flightedison-llight.png?alt=media&token=035defe5-3774-4468-9667-d69cde4ad050';
export const LightEdisonLogo2 =
  'https://firebasestorage.googleapis.com/v0/b/light-edison.appspot.com/o/LightEdison%20Logo%2BTag%20Hex%20300_6-in.png?alt=media';
export const LightEdisonLogo3 =
  'https://firebasestorage.googleapis.com/v0/b/light-edison.appspot.com/o/0.png?alt=media&token=7f273658-7756-42b8-984a-9ecd5f8d0ca1';
export const LightEdisonWiki = 'https://sites.google.com/a/lightedison.com/internal-lightedison-wiki/';
export const serviceEmail = 'cst@lightedison.com';
export const logisticsEmail = 'logistics@lightedison.com';
export const accountsPayableEmail = 'ap@lightedison.com';
export const rfiEmail = 'rfi@lightedison.com';
export const issueEmail = 'issue@lightedison.com';
export const punchListEmail = 'punchlist@lightedison.com';
export const flightRequestsEmail = 'flightrequests@lightedison.com';

//GAPI URLs & GUIDs - Sheets, Drive, Docs, Calendar, Scripts, Admin
export const exportedReportsFolder = '1-x3yPPkGgPC9rGk5E2-zXZGozqMF_vwi';
// dailyReportSheet is referenced in Field Operations Onboarding Forms, but which appear deprecated and not in use
export const dailyReportSheet = '1tY1bvqHzQYDsxXNljwUe1n6EdcFZdERJAiiLcWiBYc4';
export const fieldOperationsFolder = 'https://drive.google.com/drive/folders/1rG9Pk8e0GS_uZYK-dxhyfXuc7nElzmVI';

// Google Forms - TODO: need to be removed or stored in Sparkfund Shared Drive.
export const PORequestForm = 'https://docs.google.com/forms/d/e/1FAIpQLSeHdIG_TfJ6zx6CsnVSoGklRTUt7zPf5ZuskAdhHsSr_4u1RQ/viewform';
export const AuxiliaryEquipRequestForm =
  'https://docs.google.com/forms/d/e/1FAIpQLScyy6GvIHx3n3Hpahn1P67aAUdJfvclpd4N_Gd6zHrjx-ER4g/viewform';
export const LodgingRequestForm = 'https://docs.google.com/forms/d/e/1FAIpQLSdLgQ5JGDiNqjxSmWvmld1mB2At40JHaaPIDVAwDm2aB85JBg/viewform';
export const DeliveryReceiptForm = 'https://docs.google.com/forms/d/e/1FAIpQLSeCMQBB3Tk9zmF65KtejO17HtNWOrK2pYxo_Fm7Uy6JDYGtAQ/viewform';
export const ProjectShareFolderRequestForm =
  'https://docs.google.com/forms/d/e/1FAIpQLSebfeB2sdWGV-24VIFkPazE--ez6KOF1RB7bXi7P4_kDMT8mQ/viewform';

// Google Drive Folders - TODO: need to be removed or updated to Sparkfund Shared Drive.
export const FederalAndStateLaborLawPosters = 'https://drive.google.com/drive/u/0/folders/15OgPtAYhVtpIuTBqY-M1k82BoLTylgAV';

// DEPRECATED - files used for former LightEdison HR functionality
export const exportedPositionAgreementsFolder = '1CUULSO0TyDPz5N0vsEUCebd2oWNa2iW7';
export const positionAgreementDocument = '1PAAQFhZTAM_1IXyPEmvjKYbzg26bideANNaqFJ9glDM';
export const contractedDocument = '1dKve3pHItJCdcuEzXZnyrO5NNtdbFyj-S9GWjv4QrwA';

//Scripts
export const imageDownloadScript =
  'https://script.google.com/a/lightedison.com/macros/s/AKfycbyP_25rlTMQd3FVA6XDxirjor2gn97z3P9Q1LbmOuMowxT8WQXv/exec?opptyID=';

//Calendars
export const leaveRequestsCalendar = 'c_debb78240d3097008ece5b0eb4c25bcf4bae5cba8119c67dee138ada297cae52@group.calendar.google.com';

// Policy Document URLs:
export const ColoradoDOL =
  'https://firebasestorage.googleapis.com/v0/b/light-edison.appspot.com/o/file_uploads%2Fdepartment_of_labor_notifications%2Fdepartment_of_labor_notifications.pdf?alt=media&token=f933f73d-10df-4141-a48a-0f4e6f4d89a0';
export const OSHAForm =
  'https://firebasestorage.googleapis.com/v0/b/light-edison.appspot.com/o/file_uploads%2Fosha_300_form%2FLE%202023%20300%20A.pdf?alt=media&token=b49c1d68-cf82-496d-98e9-ee723a44b23f';
